import React, { useCallback, useEffect, useState } from "react";
import { AdminLayout } from "../../../layout/AdminLayout";
import { HeaderPage } from "../../../components/HeaderPage";
import { Button } from "../../../Korbantech/components/Buttons/Button";
import { useNavigate } from "react-router-dom";
import useApi from "../../../hooks/useApi";
import { SpinnerLoad } from "../../../components/Loading/SpinnerLoad";
import { Trail } from "../../../types/Trail";
import { TrailsAdminCard } from "../../../components/Trails/TrailsAdminCard";

export const Traill = () => {
    const navigate = useNavigate();
    const api = useApi();

    const [load, setLoad] = useState<boolean>(false);
    const [trails,setTrails] = useState<Trail[]>()

    const loadTrails = useCallback(async () => {
        setLoad(true);
        await api.get("/admin/trails").then((res) => {
            setTrails(res.data);
        });
        setLoad(false);
    }, [api, setLoad]);

    useEffect(() => {
        loadTrails();
    }, [loadTrails]);

    return (
        <AdminLayout>
            <HeaderPage
                name="Trilha de desenvolvimento"
                button={
                    <Button
                        value="Nova Trilha"
                        onClick={() => navigate("/admin/trilha/nova")}
                    />
                }
            />
            {load && <SpinnerLoad />}
            {!load && <div className="grid grid-cols-4 gap-2">
                {trails?.map(item => (
                    <div key={item.id}>
                        <TrailsAdminCard trail={item} />
                    </div>
                ))}
            </div>}
        </AdminLayout>
    );
};
